<template>
  <div>
    <!-- <div class="cover" v-if="!vistaSimplificada">
      <PortadaViz />
      <div class="cover-gradient">
        <img
          class="cover-logos a11y-contraste-fondo"
          src="@/assets/img/base/logos-gob-conahcyt.svg"
          alt="Gobierno de México y Conahcyt"
        />
        <h1 class="cover-title cover-title-large a11y-contraste-fondo">
          Red de transmisión y vigilancia de farmacorresistencia del VIH en la
          CDMX
        </h1>
        <h2 class="cover-subtitle a11y-contraste-fondo">
          Un capítulo del Ecosistema Nacional Informático de
          {{ obtenerNombreEni }}
        </h2>
      </div>
    </div> -->

    <!-- <div class="a11y-simplificada-block">
      <div class="container text m-t-2-sm m-t-3-md">
        <img
          src="@/assets/img/base/firma_compuesta.svg"
          alt="Gobierno de México y Conahcyt"
        />
      </div>
      <div class="container">
        <h2 class="titular-portada m-t-1-sm m-t-3-md m-x-auto">
          Redes de transmisión y vigilancia de farmacorresistencia del VIH en la
          CDMX
        </h2>
        <h3 class="titular-portada sub m-x-auto">
          Un capítulo del Ecosistema Nacional Informático de
          {{ obtenerNombreEni }}
        </h3>
      </div>
    </div> -->

    <div class="container text m-b-2-md">
      <h1 class="titulo m-t-1-sm m-t-3-md">Información geográfica</h1>
      <p>
        Según la Organización Mundial de la Salud (OMS), <strong>la infección por VIH continúa siendo uno de los mayores problemas para la salud pública</strong>, ya que ha cobrado 36.3 millones de vidas a nivel mundial. Lamentablemente, más del 90% de las nuevas infecciones ocurren en países de ingresos bajos y medios-bajos, donde también se ha registrado prevalencias de resistencia a la TARV  superiores al 10%. <strong>Para enfrentar esta situación, la OMS ha recomendado la implementación de encuestas de vigilancia de resistencia de VIH</strong> con representatividad nacional, que permitan informar sobre la toma de decisiones para poner en práctica políticas de salud pública.
      </p>
      <p>
        En México, de acuerdo con la Secretaría de Salud en el año 2020 se diagnosticaron 9,674 infecciones por VIH, siendo <strong>los estados de Quintana Roo, Colima y Yucatán, aquellos con las mayores tasas de nuevos casos diagnosticados</strong>. No obstante, desde que se inició el registro de las infecciones en 1983, la mayoría de los casos registrados se concentran en la Ciudad de México y el estado de Veracruz ( 81% de los registros ocurrieron en hombres). Mientras que, <strong>en el año 2015 se encontró que la prevalencia promedio a la TARV es de 13.5 %</strong>. Además, en una encuesta más reciente y enfocada a un antirretroviral específico se encontró una prevalencia de 10 %, siendo  significativamente más alta en la región sureste del país. Es por ello que, en México se han incorporado nuevas opciones de tratamiento y se recomienda  realizar pruebas de resistencia de VIH en todas las personas que inicien tratamientos con familia de los inhibidores no nucleósidos de la transcriptasa inversa. De esta manera, se vuelve fundamental mantener la vigilancia de ésta y otras resistencias, con el fin de obtener información útil para la toma de decisiones en salud pública a nivel nacional.
      </p>
      <p>
        <strong>Una de las políticas públicas que se han implementado</strong>, derivadas de estos hallazgos es la reforma a la Ley General de Salud, que a partir del  1° de enero del 2020 declara que <strong>todas las personas con VIH tienen prestación gratuita de servicios de salud, medicamentos y demás insumos asociados</strong>.
      </p>
    </div>

    <div class="container vis m-y-1 ocultar-grafica">
      <Mapa />
    </div>

    <div class="container m-y-2 ocultar-texto">
      <div class="texto-notas">
        <p><strong>Fuentes de datos:</strong></p>
        <p>
          <a 
            href="https://datos.gob.mx/busca/dataset/codigos-postales-coordenadas-y-colonias"
            >https://datos.gob.mx/busca/dataset/codigos-postales-coordenadas-y-colonias
          </a>
          (Consultado el 21 de agosto 2021)
        </p>
        <p><strong>Notas</strong></p>
        <p>
          Existen diferentes versiones de capas geográficas de códigos postales.
          Con la finalidad de mostrar la mayor cantidad de información en
          relación al estudio presentado, se seleccionó la versión del año 2016.
          Aunque existen versiones más actualizadas, estas mostrarían una menor
          cantidad de datos.
        </p>
        <p>
          Las abreviaturas "cis" y "trans" corresponden a las identidades de
          género Cisgénero y Transgénero respectivamente con la que cada
          participante se identificó al responder la encuesta.
        </p>
        <p>
          Las categorías "Seguro Popular" y “Sin seguridad” se homologaron a la categoría "INSABI".
          Ya que las personas participantes que tienen estas categorías, por derecho, pueden recibir
          servicios de salud por parte del Instituto de Salud para el Bienestar (INSABI).
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Mapa from "@/components/mapa/Mapa.vue";
import { mapState } from "vuex";

export default {
  name: "Inicio",
  components: {
    Mapa,
  },
  data() {
    return {
      domain: process.env.VUE_APP_ENI_DOMAIN,
      base_route: process.env.VUE_APP_BASE_ROUTE,
      public_path: process.env.BASE_URL,
    };
  },
  computed: {
    ...mapState(["numero_nodos_clusters", "nodos_totales"]),
    obtenerNombreEni() {
      return this.$store.getters.obtenerNombreEni;
    },
    vistaSimplificada() {
      return this.$store.getters.tieneVistaSimplificada;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
